import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getPlanTypeList,
  setFarmId,
  clearDashBoard,
  cancelPreviousDashboardRequest,
  manualLoad,
  refreshDashboard,
  setMainBoardActiveTab,
} from "../../../actions/dashboard";
import { LeaderBoard } from "../LeaderBoard";
import { connectSocket } from "../../../actions/socket";
import { isToday } from "../../../helpers/common";
import Body from "./Body";
import Header from "./Header";
import { matchPath } from "react-router-dom";
import { updateCurrentFarm } from "../../../actions/farm";
import { getLogisticsHistory } from "../../../actions/logistics";
import { getSeedHistory } from "../../../actions/plan";
import { PLANTING_PLAN_TYPE_ID } from "../../../constants";

const Layout = (props) => {
  const dispatch = useDispatch();
  const { farmId } = props;
  const collapseLeaderBoard = useSelector(state => state.dashboard.collapseLeaderBoard)
  const refreshCount = useSelector(state => state.dashboard.refreshCount)
  const dashboardFarmId = useSelector(state => state.dashboard.farmId)
  const activeTab = useSelector(state => state.dashboard.activeTab)
  const { rangeId, range, from, to } = useSelector(state => state.analyze.searchParams);
  const autoRefresh = useSelector((state) =>
    state.user.configuration.autoRefresh &&
      state.user.configuration.autoRefresh.hasOwnProperty("dashboard")
      ? state.user.configuration.autoRefresh.dashboard
      : true
  );
  const selectedPlanTypeId = useSelector((state => state.plan.selectedPlanType));
  //const dbHarvestProjection = useSelector(state => state.farm.currentFarm.is_harvest_projection_enable);
  let timerId = null;
  useEffect(() => {
    if (selectedPlanTypeId) {
      const isHarvestProjectionEnable = (selectedPlanTypeId === PLANTING_PLAN_TYPE_ID) ? false : true;
      dispatch(updateCurrentFarm({ is_harvest_projection_enable: isHarvestProjectionEnable }))
    }
  }, [selectedPlanTypeId])

  useEffect(() => {
    dispatch(getPlanTypeList());
    setActiveTab();

    if (!window.socketClient) dispatch(connectSocket());

    return () => {
      dispatch(cancelPreviousDashboardRequest());
      dispatch(clearDashBoard(false))
    };
  }, []);

  useEffect(() => {
    if (farmId !== dashboardFarmId) {
      dispatch(clearDashBoard(true));
      dispatch(setFarmId(farmId));
    }
    const paramsObj = {
      farm_uuid: farmId,
      range_type: "todate",
      from_date: from,
      to_date: to,
      plan_type_id: selectedPlanTypeId,
      include_events: true
    }

    const seedParamsObj = {
      farm_uuid: farmId,
      range_type: "todate",
      from_date: from,
      to_date: to,
      plan_type_id: PLANTING_PLAN_TYPE_ID,
      include_events: true
    }
    dispatch(getLogisticsHistory(paramsObj));
    dispatch(getSeedHistory(seedParamsObj));
  }, [farmId]);

  useEffect(() => {
    dispatch(cancelPreviousDashboardRequest());
    if (activeTab !== "loads") dispatch(manualLoad([]));
  }, [rangeId]);

  useEffect(() => {
    clearTimer();
    if (isToday(range) && autoRefresh)
      timerId = setInterval(
        () => dispatch(refreshDashboard()),
        5 * 60 * 1000
      );
    return clearTimer;
  }, [refreshCount, range, autoRefresh]);

  const clearTimer = () => {
    if (timerId) clearInterval(timerId);
    timerId = null;
  };

  useEffect(() => {
    setActiveTab();
  }, [dashboardFarmId]);

  const setActiveTab = () => {
    const matchParams = matchPath(props.location.pathname, {
      path: `/home/farm/:farmId/dashboard/:activeId?`,
      exact: false,
      strict: false,
    });
    const activeTab = matchParams.params.activeId
      ? matchParams.params.activeId
      : "crews";
    props.history.push(`${props.match.url}/${activeTab}?sub=1`);
    dispatch(setMainBoardActiveTab(activeTab));
  };

  return (
    <div className="dashboard-container d-flex">
      <div
        className={`${collapseLeaderBoard ? "leader-board collapse" : "leader-board"
          }`}
      >
        <LeaderBoard collapseLeaderBoard={collapseLeaderBoard} />
      </div>
      <div
        className={`${collapseLeaderBoard
          ? "main-board collapse mobile-h-100-scroll"
          : "main-board mobile-h-100-scroll"
          }`}
      >
        <Header {...props} />
        <Body {...props} />
      </div>
    </div>
  );
};

export default Layout;
